import { API_FLASH_MESSAGE_LIST } from "../service/url";
import { getApiCall } from "./getApiCall";

export const fetchAndSetFlashMessage = (
  filterFn1,
  setStateFn1,
  filterFn2 = null,
  setStateFn2 = null
) => {
  getApiCall(API_FLASH_MESSAGE_LIST)
    .then(res => {
      const filteredMessage1 = res.find(filterFn1);
      setStateFn1(filteredMessage1?.message ?? "");

      if (filterFn2 && setStateFn2) {
        const filteredMessage2 = res.find(filterFn2);
        setStateFn2(filteredMessage2?.message ?? "");
      }
    })
    .catch(err => {
      console.error("Error fetching messages:", err);
    });
};